// extracted by mini-css-extract-plugin
export default {"pageWrap":"oc-z","fullWidth":"pc-z","heading":"qc-z","fullBleed":"rc-z","hidden":"sc-z"};